import { Component, DestroyRef, effect, inject, input, output, signal } from '@angular/core';
import { finalize } from 'rxjs';

import { OrderActionPopup } from '../../../../../../../shared/ui/order-action-popup/order-action-popup';
import { SuccessfulNotification } from '../../../../../../../utils/successful-notification/successful-notification';

import { UndeliveredReason } from '../../../../../../../pages/admin-dashboard/orders-management/view-order/view-order.model';
import { UndeliverOrderRequest } from '../../../../../../../pages/admin-dashboard/orders-management/orders.model';

import { ReasonsService } from '../../../../../../../services/reasons/reasons.service';
import { OrderService } from '../../../../../../../services/orders/order.service';
import { HasScopeDirective } from '../../../../../../../services/scope/has-scope.directive';
import { SCOPES } from '../../../../../../../services/scope/scope-constants';

@Component({
  selector: 'app-undeliver-popup',
  standalone: true,
  imports: [OrderActionPopup, SuccessfulNotification, HasScopeDirective],
  templateUrl: './undeliver-popup.html',
  styleUrl: './undeliver-popup.scss',
})
export class UndeliverPopup {
  private destroyRef = inject(DestroyRef);
  private reasonsService = inject(ReasonsService);
  private orderService = inject(OrderService);
  readonly SCOPES = SCOPES;

  orderId = input<string | number | null>(null);

  isOpen = input(false);

  isArabic = input(false);

  undeliveredReasons = signal<UndeliveredReason[]>([]);

  undelivering = signal(false);

  errorShip = signal('');

  undeliverSuccess = signal(false);

  success = output<void>();

  close = output<void>();

  constructor() {
    effect(() => {
      if (this.isOpen()) {
        this.openUndeliverPopup();
      }
    });
  }

  openUndeliverPopup() {
    this.errorShip.set('');
    this.loadUndeliveredReasons();
  }

  // loadUndeliveredReasons() {
  //   this.reasonsService.getUndeliveredReasons().subscribe({
  //     next: (response) => {
  //       console.log('UNDELIVER REASONS:', response);

  //       this.undeliveredReasons.set(response.list ?? []);
  //     },

  //     error: (error) => {
  //       console.error('UNDELIVER REASONS ERROR:', error);

  //       this.errorShip.set(
  //         this.isArabic()
  //           ? error?.error?.messageAr ||
  //             error?.messageAr ||
  //             'حدث خطأ أثناء تحميل أسباب عدم التسليم'
  //           : error?.error?.messageEn ||
  //             error?.messageEn ||
  //             'Failed to load undelivered reasons',
  //       );
  //     },
  //   });
  // }
  loadUndeliveredReasons() {
    const subscription = this.reasonsService.getUndeliveredReasons().subscribe({
      next: (response) => {
        const reasons = response.list ?? [];

        this.undeliveredReasons.set(reasons);
      },

      error: (error) => {
        this.errorShip.set(
          this.isArabic()
            ? error?.error?.messageAr || error?.messageAr || 'حدث خطأ أثناء تحميل أسباب عدم التسليم'
            : error?.error?.messageEn || error?.messageEn || 'Failed to load undelivered reasons',
        );
      },
    });

    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  onCloseUndeliver() {
    this.close.emit();
    this.errorShip.set('');
  }

  onUndeliverOrder(reasonId: number | null, otherReason: string, comment: string) {
    const id = this.orderId();

    if (!id || reasonId === null) {
      return;
    }

    const data: UndeliverOrderRequest = {
      reason: {
        reasonId,
        otherReason: otherReason,
      },
      comment,
    };

    this.undelivering.set(true);
    this.errorShip.set('');

    console.log('UNDELIVER ORDER ID:', id);
    console.log('UNDELIVER BODY:', data);
    const subscription = this.orderService
      .undeliverOrder(String(id), data)
      .pipe(
        finalize(() => {
          this.undelivering.set(false);
        }),
      )
      .subscribe({
        next: () => {
          this.undeliverSuccess.set(true);

          setTimeout(() => {
            this.close.emit();
            this.undeliverSuccess.set(false);
          }, 3000);

          this.success.emit();
        },

        error: (error) => {
          console.error('UNDELIVER ERROR:', error);

          this.errorShip.set(
            this.isArabic()
              ? error?.error?.messageAr || 'حدث خطأ أثناء إلغاء التسليم'
              : error?.error?.messageEn || 'Failed to undeliver the order',
          );
        },
      });

    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }
}
